<template>
    <div>
        
        <div class="header-container">
            <menu-title :name="$route.params.data.name" :icon-class="$route.params.data.icon"></menu-title>          
            <div class="count-container"> 
                <span class="count-text">Fluxo do cadastro de convidados</span>
            </div>
            <hr> 
        </div>

        <div class="flow-container">
            <div class="container-fluid p-0">
                
                <div class="card-body py-2">
                    <div class="row">
                        <div class="col-sm-6">
                            <h5 class="card-title">Dados do Fluxo</h5>
                            <div class="form-group">
                                <label class="col-form-label">Nome</label>
                                <input class="form-control" v-model="form.name" placeholder="Ex.: Fluxo Exemplo" required />
                            </div>
                                          
                            <div class="form-group">
                                <label class="col-form-label">Logo</label>
                                <input ref="logoFile" class="form-control" type="file" accept="image/*" @change="onLogoFileChange"/>
                            </div>
                            <div v-if="form.flow.settings.logo" class="mb-1 text-muted small">Arquivo selecionado: {{ form.flow.settings.logo }}</div>
                            <div v-if="logoPreviewUrl" class="mb-2">
                                <img :src="logoPreviewUrl" alt="logo" style="max-height:80px" required/>
                            </div>

                            <div class="form-group">
                                <div class="form-check">
                                    <input id="default_check" class="form-check-input" type="checkbox" v-model="form.default">
                                    <label class="form-check-label" for="default_check">Definir como fluxo padrão</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input id="qrcode_check" class="form-check-input" type="checkbox" v-model="form.generateQrcode">
                                    <label class="form-check-label" for="qrcode_check">Gerar QR Code para visitantes</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Cor primária</label>
                                <input type="color" class="form-control form-control-color" v-model="form.flow.settings.colors.primary" title="Escolha uma cor">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Cor secundária</label>
                                <input type="color" class="form-control form-control-color" v-model="form.flow.settings.colors.secondary" title="Escolha uma cor">
                            </div>

                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <h5 class="card-title">Documentos (JSON)</h5>
                            <div class="form-group">
                                <input ref="documentsFiles" class="form-control" type="file" accept="application/json" multiple @change="onDocumentsFilesChange"/>
                            </div>
                            <ul class="list-group" v-if="documentsList.length">
                                <li v-for="(doc, idx) in documentsList" :key="idx" class="list-group-item d-flex justify-content-between align-items-center">
                                    {{ doc.name }}
                                    <span class="badge badge-secondary badge-pill">{{ doc.size }} bytes</span>
                                </li>
                            </ul>
                            <small class="text-muted">A estrutura do json deve ser: { "title":"Termos de uso", "content": "Algum Conteúdo", "version": "1.0.0"  }</small>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">Definição dos Flows e Steps</h5>
                                <button class="btn btn-outline-primary btn-sm" @click="addFlow">Adicionar Flow</button>
                            </div>
                            <div v-for="(f, fIdx) in form.flow.flows" :key="fIdx" class="flow-box mt-2">
                                <div class="flow-header d-flex align-items-center">
                                    <div class="form-inline">
                                        <label class="mr-2">ID do Fluxo</label>
                                        <input class="form-control mr-2" v-model="f.id" placeholder="ex.: main"/>
                                    </div>
                                    <button class="btn btn-outline-danger btn-sm ml-auto" @click="removeFlow(fIdx)">Remover Flow</button>
                                </div>
                                <div class="flow-header-line"></div>
                                <div class="steps-box">
                                    <div class="d-flex justify-content-between align-items-center add-step-title-button">
                                        <h6 class="mb-2">Passos</h6>
                                        <button class="btn btn-outline-primary btn-sm" @click="addStep(fIdx)">Adicionar Step</button>
                                    </div>
                                    <div v-if="!f.steps || f.steps.length===0" class="text-muted">Nenhum step adicionado.</div>
                                    <div v-for="(s, sIdx) in f.steps" :key="sIdx" class="step-item">
                                        <div class="d-flex align-items-center step-header">
                                            <div class="form-inline">
                                                <label class="mr-2">Tipo</label>
                                                <select class="form-control" v-model="s.type" @change="onStepTypeChange(fIdx, sIdx)">
                                                    <option value="welcome">Bem-vindo</option>
                                                    <option value="terms">Termos</option>
                                                    <option value="identification">Identificação</option>
                                                    <option value="personalData">Dados Pessoais</option>
                                                    <option value="picture">Foto</option>
                                                    <option value="responsible">Responsável</option>
                                                    <option value="document">Documento</option>
                                                    <option value="decision">Passo de decisão</option>
                                                    <option value="finish">Passo final</option>
                                                </select>
                                            </div>
                                            <div class="ml-auto">
                                                <button class="btn btn-outline-secondary btn-sm mr-1" @click="moveStep(fIdx, sIdx, -1)" :disabled="sIdx===0">↑</button>
                                                <button class="btn btn-outline-secondary btn-sm mr-2" @click="moveStep(fIdx, sIdx, 1)" :disabled="sIdx===f.steps.length-1">↓</button>
                                                <button class="btn btn-outline-danger btn-sm" @click="removeStep(fIdx, sIdx)">Remover</button>
                                            </div>
                                        </div>
                                        <div class="step-body">
                                            <div v-if="['welcome','picture','finish'].includes(s.type)">
                                                <div class="form-group">
                                                    <label>Mensagem</label>
                                                    <input class="form-control" v-model="s.msg"/>
                                                </div>
                                                <div class="form-group" v-if="s.type==='finish'">
                                                    <label>Timeout (ms)</label>
                                                    <input type="number" min="0" class="form-control" v-model="s.timeout"/>
                                                </div>
                                            </div>
                                            <div v-else-if="s.type==='terms'">
                                                <div class="form-group"><label>Título</label><input class="form-control" v-model="s.title"/></div>
                                                <div class="form-group"><label>Conteúdo</label><textarea class="form-control" rows="3" v-model="s.content"></textarea></div>
                                                <div class="form-group"><label>Link</label><input class="form-control" v-model="s.link"/></div>
                                                <div class="form-group">
                                                    <label>
                                                        Documento Público
                                                        <button v-if="s.publicDocumentId" style="padding: 0px 7px;font-size: 11px;" class="btn btn-outline-danger btn-sm" @click="s.publicDocumentId=''">x</button>
                                                    </label>
                                                    <input v-if="s.publicDocumentId" :disabled="s.publicDocumentId" class="form-control" v-model="s.publicDocumentId"/>
                                                    <select v-if="!s.publicDocumentId" class="form-control" v-model="s.publicDocumentId">
                                                        <option value="">Selecione um termo</option>
                                                        <option v-for="docFile in publicDocumentsFiles" :value="docFile.name" v-bind:key="docFile.name" >
                                                            {{ docFile.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div v-else-if="s.type==='identification'">
                                                <div class="form-group"><label>Mensagem</label><input class="form-control" v-model="s.msg"/></div>
                                                <div class="form-group"><label>Tipos de Documento (separados por vírgula)</label><input class="form-control" v-model="s.documentTypesText" placeholder="ex.: CPF,RG"/></div>
                                            </div>
                                            <div v-else-if="s.type==='personalData'">
                                                <div class="form-group"><label>Mensagem</label><input class="form-control" v-model="s.msg"/></div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <h6 class="mb-2">Campos</h6>
                                                    <button class="btn btn-outline-primary btn-sm" @click="addPersonalField(fIdx, sIdx)">Adicionar Campo</button>
                                                </div>
                                                <div v-if="!s.fields || s.fields.length===0" class="text-muted">Nenhum campo adicionado.</div>
                                                <div v-for="(field, fi) in (s.fields||[])" :key="fi" class="pd-field-item">
                                                    <div class="form-row">
                                                        <div class="col"><label>Nome</label><input class="form-control" v-model="field.name"/></div>
                                                        <div class="col"><label>Tipo</label>
                                                            <select class="form-control" v-model="field.type">
                                                                <option value="text">Texto</option>
                                                                <option value="phone">Telefone</option>
                                                                <option value="email">E-mail</option>
                                                            </select>
                                                        </div>
                                                        <div class="col"><label>Nome campo no JSON</label><input class="form-control" v-model="field.jsonField"/></div>
                                                        <div class="col"><label>width</label><input class="form-control" v-model="field.width" placeholder="ex.: 50%"/></div>
                                                        <div class="col d-flex align-items-center"><div class="form-check mt-4"><input class="form-check-input" type="checkbox" v-model="field.required"/> <label class="form-check-label">Obrigatório</label></div></div>
                                                        <div class="col-1 d-flex align-items-end"><button class="btn btn-outline-danger btn-sm" @click="removePersonalField(fIdx, sIdx, fi)">X</button></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else-if="s.type==='responsible'">
                                                <div class="form-group"><label>Nome campo no JSON</label><input class="form-control" v-model="s.jsonField"/></div>
                                                <div class="form-group"><label>Mensagem</label><input class="form-control" v-model="s.msg"/></div>
                                                <div class="form-group"><label>Mensagem quando sem opção</label><input class="form-control" v-model="s.noOptionMsg"/></div>
                                            </div>
                                            <div v-else-if="s.type==='document'">
                                                <div class="form-group"><label>Mensagem</label><input class="form-control" v-model="s.msg"/></div>
                                                <div class="form-group">
                                                    <label>
                                                        Documento
                                                        <button v-if="s.documentId" style="padding: 0px 7px;font-size: 11px;" class="btn btn-outline-danger btn-sm" @click="s.documentId=''">x</button>
                                                    </label>
                                                    <input v-if="s.documentId" :disabled="s.documentId" class="form-control" v-model="s.documentId"/>
                                                    
                                                    <select v-if="!s.documentId" class="form-control" v-model="s.documentId">
                                                        <option value="">Selecione um documento</option>
                                                        <option v-for="docFile in documentsFiles" :value="docFile.name" v-bind:key="docFile.name">
                                                            {{ docFile.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div v-else-if="s.type==='decision'">
                                                <div class="form-group"><label>Pergunta</label><input class="form-control" v-model="s.question"/></div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <h6 class="mb-2">Alternativas</h6>
                                                    <button class="btn btn-outline-primary btn-sm" @click="addAlternative(fIdx, sIdx)">Adicionar Alternativa</button>
                                                </div>
                                                <div v-if="!s.alternatives || s.alternatives.length===0" class="text-muted">Nenhuma alternativa adicionada.</div>
                                                <div v-for="(alt, ai) in (s.alternatives||[])" :key="ai" class="alt-item">
                                                    <div class="form-row">
                                                        <div class="col"><label>Opção</label><input class="form-control" v-model="alt.option"/></div>
                                                        <div class="col"><label>Fluxo destino</label><input class="form-control" v-model="alt.flow" placeholder="ex.: withMinor"/></div>
                                                        <div class="col-1 d-flex align-items-end"><button class="btn btn-outline-danger btn-sm" @click="removeAlternative(fIdx, sIdx, ai)">X</button></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-sm-12">
                            <button :disabled="!canSubmit || isSubmitting" class="btn btn-primary mr-2" @click="saveFlow">
                                {{ isSubmitting ? 'Salvando...' : (form.id ? 'Atualizar Fluxo' : 'Criar Fluxo') }}
                            </button>
                            <button v-if="form.id" :disabled="isSubmitting" class="btn btn-secondary" @click="resetForm">Cancelar edição</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div class="card mt-3">
                            <div class="card-body">
                                <h5 class="card-title">Fluxos existentes</h5>
                                <div v-if="flows.length === 0" class="text-muted">Nenhum fluxo cadastrado.</div>
                                <ul class="list-group" v-else>
                                    <li v-for="f in flows" :key="f.id" class="list-group-item d-flex justify-content-between align-items-center">
                                        <span @click="editFlow(f)" style="cursor:pointer">
                                            <b>{{ f.name }}</b>
                                            <span class="badge badge-secondary ml-2">{{ f.default ? 'Padrão' : 'Secundário' }}</span>
                                            <span v-if="f.generateQrcode" class="badge badge-warning ml-2">QR Code</span>
                                        </span>
                                        <span>
                                            <button v-if="!f.default" class="btn btn-outline-primary btn-sm mr-2" @click.stop="makeDefault(f)">Tornar padrão</button>
                                            <button class="btn btn-outline-danger btn-sm" @click.stop="showConfirmRemoveFlow(f)">Remover</button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <confirm-remove 
                id="flow-remove-confirm-modal" 
                question="Excluir Fluxo?"
                success-message="Fluxo excluído com sucesso."
                :input-confirm="true"
                :confirm-method="confirmRemoveFlow"
            ></confirm-remove>
        </div>

        

    </div>
</template>

<script>

    import selfRegisterService from '../services/SelfRegisterService';
    import PermissionService from '../services/PermissionService';
    import MenuService from '../services/MenuService';
    import { eventBus } from '../main';

    export default {
        name: 'Flow',
        data: () => ({
            // existing state kept if needed later
            credentials: [],
            credential: { permissions: [] },
            permissions: [],

            // flow builder state
            flows: [],
            form: {
                id: null,
                name: 'Fluxo Exemplo',
                default: true,
                generateQrcode: false,
                flow: {
                    settings: {
                        logo: '',
                        colors: { primary: '#1040C6', secondary: '#00BDFF' }
                    },
                    flows: [
                        {
                            id: 'main',
                            steps: [
                                { type: 'welcome', msg: 'Bem vindo a TOPTIC!' },
                                { type: 'terms', title: 'Termos de privacidade', content: 'Ao prosseguir com o seu cadastro, você concorda com o compartilhamento dos seus dados com a organização ao qual você irá visitar.\nAlgumas organizações podem inclusive utilizar a sua foto como credencial de acesso durante a sua visita.\nApós a data de finalização da sua visita, seus dados serão removidos do nosso sistema em poucos dias.\nPara maiores informações, consulte nossa política de privacidade e dados do usuário.', link: 'Clique aqui para visualizar os termos de privacidade!', publicDocumentId: '' },
                                { type: 'identification', msg: 'Vamos começar. Informe o número do seu CPF!', documentTypesText: 'CPF' },
                                { type: 'personalData', msg: 'Informe seus dados pessoais', fields: [
                                    { name: 'Nome', type: 'text', jsonField: 'name', required: true, width: '50%' },
                                    { name: 'Sobrenome', type: 'text', jsonField: 'lastName', required: true, width: '50%' },
                                    { name: 'Telefone', type: 'phone', jsonField: 'phoneNumber', required: true },
                                    { name: 'Email', type: 'email', jsonField: 'emailAddress', required: true }
                                ] },
                                { type: 'picture', msg: 'Vamos registrar este momento!' },
                                { type: 'responsible', jsonField: 'responsible', msg: 'Quem você irá visitar?', noOptionMsg: 'Não há alguém específico ou não me recordo.' },
                                { type: 'document', msg: 'Leia com atenção o termo abaixo', documentId: '' },
                                { type: 'decision', question: 'Você está acompanhado de menor?', alternatives: [
                                    { option: 'Sim', flow: 'withMinor' },
                                    { option: 'Não', flow: 'withoutMinor' }
                                ] }
                            ]
                        },
                        {
                            id: 'withMinor',
                            steps: [
                                { type: 'document', msg: 'Leia com atenção o termo abaixo', documentId: '' },
                                { type: 'finish', msg: 'Seja muito bem vindo à TOPTIC!', timeout: "6000" }
                            ]
                        },
                        {
                            id: 'withoutMinor',
                            steps: [
                                { type: 'finish', msg: 'Seja muito bem vindo à TOPTIC!', timeout: "6000" }
                            ]
                        }
                    ]
                }
            },
            logoFile: null,
            logoPreviewUrl: '',
            documentsFiles: [],
            isSubmitting: false,
            publicDocumentsFiles: []
        }),
        components: {
        },
        computed: {
            canSubmit(){
                if(!this.form.flow) return false;
                return true;
            }
            ,
            documentsList(){
                return (this.documentsFiles || []).map(f => ({ name: f.name, size: f.size }))
            }
        },
        methods: {
            async loadFlows(){
                this.flows = await selfRegisterService.getFlows(this.selectedAccount.id);
            },
            onLogoFileChange(e){
                const file = e.target.files[0];
                this.logoFile = file || null;
                this.logoPreviewUrl = file ? URL.createObjectURL(file) : '';
                if(file){
                    this.form.flow.settings.logo = file.name;
                }
            },
            onDocumentsFilesChange(e){
                const files = Array.from(e.target.files || []);
                this.documentsFiles = files;
            },
            extractDependencies(flowContent){
                const images = flowContent?.flow?.settings?.logo ? [flowContent.flow.settings.logo] : [];
                const documents = [];
                let publicDocument = null;
                (flowContent?.flow?.flows || []).forEach(flow => {
                    (flow.steps || []).forEach(step => {
                        if(step.type === 'document' && step.documentId){
                            documents.push(step.documentId);
                        }
                        if(step.type === 'terms' && step.publicDocumentId){
                            publicDocument = step.publicDocumentId;
                        }
                    })
                })
                return { images, documents, publicDocument };
            },
            async uploadImages(deps){
                const accountId = this.selectedAccount.id;
                const map = new Map();
                for(const imgName of deps.images){
                    if(!this.logoFile || !imgName) continue;
                    const imageInfo = await selfRegisterService.createImage(accountId, imgName);
                    await selfRegisterService.uploadImageMedia(accountId, imageInfo.id, this.logoFile);
                    map.set(imgName, imageInfo.id);
                }
                return map;
            },
            async createDocuments(deps){
                const accountId = this.selectedAccount.id;
                const map = new Map();
                for(const docName of deps.documents){
                    const file = this.documentsFiles.find(f => f.name === docName);
                    if(!file) continue;
                    const text = await file.text();
                    const json = JSON.parse(text);
                    const created = await selfRegisterService.createDocument(accountId, { name: docName, ...json });
                    map.set(docName, created.id);
                }
                if(deps.publicDocument){
                    const publicDocs = await selfRegisterService.getPublicDocuments();
                    const found = publicDocs.find(d => d.name === deps.publicDocument);
                    if(found){
                        map.set(deps.publicDocument, found.id);
                    }
                }
                return map;
            },
            replaceReferences(bodyText, refsMap){
                let out = bodyText;
                refsMap.forEach((value, key) => { out = out.split(key).join(value); });
                return out;
            },
            async saveFlow(){

                if(!this.form.name){
                    eventBus.$emit('showWarnMessage', 'Nome do fluxo é obrigatório');
                    return;
                } 
                if(!this.form.flow.settings.logo){
                    eventBus.$emit('showWarnMessage', 'Logo é obrigatório');
                    return;
                } 

                if(!this.form.flow.settings.colors.primary){
                    eventBus.$emit('showWarnMessage', 'Cor primária é obrigatório');
                    return;
                } 

                if(!this.form.flow.settings.colors.secondary){
                    eventBus.$emit('showWarnMessage', 'Cor secundária é obrigatório');
                    return;
                } 

                
                const identificationSteps = this.form.flow.flows[0].steps.filter(step => step.type === 'identification');

                if (identificationSteps.length === 0) {
                    eventBus.$emit('showWarnMessage','Passo de identificação é obrigatório!');
                    return;
                }

                this.isSubmitting = true;
                
                try{

                    this.normalizeSteps();
                    const deps = this.extractDependencies(this.form);
                    const imageMap = await this.uploadImages(deps);
                    const docMap = await this.createDocuments(deps);
                    const refs = new Map([...imageMap, ...docMap]);
                    let body = JSON.stringify(this.form);
                    body = this.replaceReferences(body, refs);
                    const parsed = JSON.parse(body);
                    const payload = this.sanitizePayload(parsed);
                    let res;

                    if(parsed.id){
                        res = await selfRegisterService.updateFlow(this.selectedAccount.id, parsed.id, payload);
                        eventBus.$emit('showSuccessMessage', `Fluxo atualizado com sucesso. ID: ${res.id}`);
                    } else {
                        res = await selfRegisterService.createFlow(this.selectedAccount.id, payload);
                        eventBus.$emit('showSuccessMessage', `Fluxo criado com sucesso. ID: ${res.id}`);
                    }
                    
                    if(payload.default){
                        await this.unsetDefaultFromOthers(res.id);
                        try{ 
                            await selfRegisterService.updateAllInvitesToDefaultFlow(this.selectedAccount.id); 
                        } catch(e){
                            console.error(e);
                        }
                    }
                    
                    this.resetForm();
                    
                    await this.loadFlows();

                }catch(err){
                    eventBus.$emit('showErrorMessage', `Falha ao salvar fluxo: ${err.message || err}`);
                } finally {
                    this.isSubmitting = false;
                }
            },
            sanitizePayload(obj){
                return {
                    name: obj.name,
                    default: !!obj.default,
                    generateQrcode: !!obj.generateQrcode,
                    flow: obj.flow
                }
            },
            normalizeSteps(){
                (this.form.flow.flows || []).forEach(flow => {
                    (flow.steps || []).forEach(step => {
                        if(step.type === 'identification'){
                            if(step.documentTypesText && typeof step.documentTypesText === 'string'){
                                step.documentTypes = step.documentTypesText.split(',').map(s=>s.trim()).filter(Boolean)
                            }
                            delete step.documentTypesText
                        }
                    })
                })
            },
            addFlow(){ this.form.flow.flows.push({ id:'', steps:[] }) },
            removeFlow(idx){ this.form.flow.flows.splice(idx,1) },
            addStep(fIdx){ const f=this.form.flow.flows[fIdx]; f.steps=f.steps||[]; f.steps.push({ type:'welcome', msg:'' }) },
            removeStep(fIdx,sIdx){ const f=this.form.flow.flows[fIdx]; f.steps.splice(sIdx,1) },
            moveStep(fIdx,sIdx,dir){ const f=this.form.flow.flows[fIdx]; const t=sIdx+dir; if(t<0||t>=f.steps.length) return; const [it]=f.steps.splice(sIdx,1); f.steps.splice(t,0,it) },
            onStepTypeChange(fIdx,sIdx){ const f=this.form.flow.flows[fIdx]; const s=f.steps[sIdx]; f.steps.splice(sIdx,1,this.newStepTemplate(s.type)) },
            newStepTemplate(type){
                switch(type){
                    case 'welcome': return { type, msg:'' }
                    case 'terms': return { type, title:'', content:'', link:'', publicDocumentId:'' }
                    case 'identification': return { type, msg:'', documentTypesText:'' }
                    case 'personalData': return { type, msg:'', fields:[] }
                    case 'picture': return { type, msg:'' }
                    case 'responsible': return { type, jsonField:'responsible', msg:'', noOptionMsg:'' }
                    case 'document': return { type, msg:'', documentId:'' }
                    case 'decision': return { type, question:'', alternatives:[] }
                    case 'finish': return { type, msg:'', timeout: '6000' }
                    default: return { type }
                }
            },
            addPersonalField(fIdx,sIdx){ const s=this.form.flow.flows[fIdx].steps[sIdx]; s.fields=s.fields||[]; s.fields.push({ name:'', type:'text', jsonField:'', required:true, width:'50%' }) },
            removePersonalField(fIdx,sIdx,fi){ const s=this.form.flow.flows[fIdx].steps[sIdx]; s.fields.splice(fi,1) },
            addAlternative(fIdx,sIdx){ const s=this.form.flow.flows[fIdx].steps[sIdx]; s.alternatives=s.alternatives||[]; s.alternatives.push({ option:'', flow:'' }) },
            removeAlternative(fIdx,sIdx,ai){ const s=this.form.flow.flows[fIdx].steps[sIdx]; s.alternatives.splice(ai,1) },
            async editFlow(flow){
                this.form = JSON.parse(JSON.stringify(flow));
                this.logoPreviewUrl = '';
                this.logoFile = null;
                this.documentsFiles = [];              
                (this.form.flow.flows || []).forEach(flow => {
                    (flow.steps || []).forEach(step => {
                        if(step.type !== 'identification'){
                           return;
                        }
                        if(step.documentTypes && step.documentTypes.length > 0){
                            step.documentTypesText = step.documentTypes.join(",");
                        }
                    })
                })
                const imgFile = await selfRegisterService.getImage(this.selectedAccount.id, this.form.flow.settings.logo);
                this.logoPreviewUrl = URL.createObjectURL(imgFile.data);
            },
            resetForm(){ 
                this.form = {
                    id: null,
                    name: 'Fluxo Exemplo',
                    default: true,
                    generateQrcode: false,
                    flow: {
                        settings: {
                            logo: '',
                            colors: { primary: '#1040C6', secondary: '#00BDFF' }
                        },
                        flows: [
                            {
                                id: 'main',
                                steps: [
                                    { type: 'welcome', msg: 'Bem vindo a TOPTIC!' },
                                    { type: 'terms', title: 'Termos de privacidade', content: 'Ao prosseguir com o seu cadastro, você concorda com o compartilhamento dos seus dados com a organização ao qual você irá visitar.\nAlgumas organizações podem inclusive utilizar a sua foto como credencial de acesso durante a sua visita.\nApós a data de finalização da sua visita, seus dados serão removidos do nosso sistema em poucos dias.\nPara maiores informações, consulte nossa política de privacidade e dados do usuário.', link: 'Clique aqui para visualizar os termos de privacidade!', publicDocumentId: '' },
                                    { type: 'identification', msg: 'Vamos começar. Informe o número do seu CPF!', documentTypesText: 'CPF' },
                                    { type: 'personalData', msg: 'Informe seus dados pessoais', fields: [
                                        { name: 'Nome', type: 'text', jsonField: 'name', required: true, width: '50%' },
                                        { name: 'Sobrenome', type: 'text', jsonField: 'lastName', required: true, width: '50%' },
                                        { name: 'Telefone', type: 'phone', jsonField: 'phoneNumber', required: true },
                                        { name: 'Email', type: 'email', jsonField: 'emailAddress', required: true }
                                    ] },
                                    { type: 'picture', msg: 'Vamos registrar este momento!' },
                                    { type: 'responsible', jsonField: 'responsible', msg: 'Quem você irá visitar?', noOptionMsg: 'Não há alguém específico ou não me recordo.' },
                                    { type: 'document', msg: 'Leia com atenção o termo abaixo', documentId: '' },
                                    { type: 'decision', question: 'Você está acompanhado de menor?', alternatives: [
                                        { option: 'Sim', flow: 'withMinor' },
                                        { option: 'Não', flow: 'withoutMinor' }
                                    ] }
                                ]
                            },
                            {
                                id: 'withMinor',
                                steps: [
                                    { type: 'document', msg: 'Leia com atenção o termo abaixo', documentId: '' },
                                    { type: 'finish', msg: 'Seja muito bem vindo à TOPTIC!', timeout: "6000" }
                                ]
                            },
                            {
                                id: 'withoutMinor',
                                steps: [
                                    { type: 'finish', msg: 'Seja muito bem vindo à TOPTIC!', timeout: "6000" }
                                ]
                            }
                        ]
                    }
                };
                this.logoFile = null;
                this.logoPreviewUrl = '';
                this.documentsFiles = [];
            },
            async makeDefault(flow){
                try{
                    const updated = this.sanitizePayload({ ...flow, default: true });
                    await selfRegisterService.updateFlow(this.selectedAccount.id, flow.id, updated);
                    await this.unsetDefaultFromOthers(flow.id);
                    try { await selfRegisterService.updateAllInvitesToDefaultFlow(this.selectedAccount.id); } catch(e) { console.error(e) }
                    eventBus.$emit('showSuccessMessage', 'Fluxo definido como padrão.');
                    await this.loadFlows();
                }catch(err){
                    eventBus.$emit('showErrorMessage', `Falha ao definir padrão: ${err.message || err}`);
                }
            },
            async unsetDefaultFromOthers(keptDefaultId){
                // Desmarca o default de outros fluxos
                const others = (this.flows || []).filter(f => f.id !== keptDefaultId && f.default);
                for(const f of others){
                    const payload = this.sanitizePayload({ ...f, default:false });
                    try{ await selfRegisterService.updateFlow(this.selectedAccount.id, f.id, payload); }catch(e){ console.error(e) }
                }
            },
            showConfirmRemoveFlow(flow){
                this.selectedFlowToRemove = flow;
                window.$('#flow-remove-confirm-modal').modal();
            },
            async confirmRemoveFlow(){
                if(!this.selectedFlowToRemove) return;
                try{
                    await selfRegisterService.removeFlow(this.selectedAccount.id, this.selectedFlowToRemove.id);
                    eventBus.$emit('showSuccessMessage', 'Fluxo removido com sucesso.');
                    await this.loadFlows();
                }catch(err){
                    eventBus.$emit('showErrorMessage', `Falha ao remover fluxo: ${err.message || err}`);
                }
            },
            onSubmit(){}
        },
        async created() {
            this.selectedAccount = this.$store.state.selectedAccount;
            const permissionService = new PermissionService(this.$store.state.userPermissions);
            if(!permissionService.hasPermissions('MANAGE_FLOWS')){
                const menuService = new MenuService(this.$router);
                menuService.goToWelcomePage();
                return;
            }
            this.permissions = permissionService.getPermissions();
            this.loadFlows();
            this.publicDocumentsFiles = await selfRegisterService.getPublicDocuments();
            
        }
    }

</script>

<style scoped>

    .flow-container {
        padding: 10px;
        padding-bottom: 56px;
        display: block;
        height: calc(100vh - 160px);
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    }

    .form-check {
        padding-left: 22px;
        padding-top: 5px;
    }

    .form-check label { 
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.1px;
        color: #000000;
    }

    .flow-header {
        padding-bottom: 10px;
    }

    .flow-preview {
        height: 160px;
        overflow: auto;
        background: #f5f5f5;
        border: 1px solid #e0e0e0;
        padding: 10px;
        border-radius: 4px;
        font-size: 12px;
    }
    .flow-box {
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 10px;
        background: #fff;
    }
    .steps-box {
        max-height: 50vh;
        overflow-y: auto;
        padding-right: 6px;
    }
    .step-item {
        border: 1px dashed #e0e0e0;
        border-radius: 6px;
        padding: 10px;
        margin-bottom: 10px;
        background: #fafafa;
    }

    .step-header {
        padding-bottom: 10px;
    }

    .add-step-title-button {
        padding-bottom: 5px;
    }
    
    .flow-header-line { 
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        margin-bottom: 10px;
    }

    .card-body {
        padding: 1rem;
    }

    .form-control-color {
        cursor: pointer;
        padding: 0px;
    }

</style>
